/* ==========================================================================
   A TRATOR DIESEL — peça esgotada e ícone do botão de comprar
   --------------------------------------------------------------------------
   1. Peça sem estoque não mostra código nem preço, nem no card nem na página
      do produto. No lugar entra "Consulte disponibilidade". Preço de peça que
      não dá para comprar só serve para a pessoa decorar um número que pode
      mudar até a peça voltar.

   2. Esgotada vai para o fim da vitrine. A Shopify não tem essa ordenação
      nativa: coleção só ordena por título, preço, data e mais vendidos. Então
      o card recebe order: 1 na grade, o que o joga para depois de todos os
      que têm estoque, dentro da página atual.

      DEFEITO CORRIGIDO EM 19/09: "dentro da página atual" era o problema.
      Relato do cliente: "chego no fim, vejo os esgotados, aí carrega mais
      produto e eles pulam de novo para o fim; é como se estivessem no fim da
      página e não no fim da fila". A grade rola infinito (results-list com
      infinite-scroll), e cada lote novo entra com order 0, ou seja, na frente
      de quem está com order 1.

      Conserto: enquanto faltar página para carregar, o esgotado fica fora da
      tela; quando a última página chega, ele aparece, sempre no fim. O tema
      dá os dois números de graça: `data-last-page` na grade (ul.product-grid)
      e `data-page` em cada card (li.product-grid__item). Nada de contar
      produto por conta própria, que quebraria com filtro aplicado.

      Coleção de uma página só (todas as da loja menos Yanmar, que tem 76)
      mostra o esgotado na hora, porque já está na última página.

      A visibilidade é escrita em `style`, não em classe de folha, e o
      observador só escuta `childList`: mudança de atributo não o acorda, então
      não há laço.

   3. Ícone do botão de comprar. O do tema é uma sacola vista de lado, que
      ninguém identifica em 18px. Trocado por um carrinho com um sinal de
      mais, que é o desenho que a pessoa já conhece de qualquer outra loja.

      Foi por JS e não por máscara CSS de propósito: com data URI, o Chrome
      deixava mask-size em auto e não pintava nada. Medido em 02/09.

   ATENÇÃO, defeito corrigido em 04/09: o botão tem DOIS ícones dentro.

     <span class="svg-wrapper add-to-cart-icon">      carrinho
     <span class="svg-wrapper add-to-cart__added-icon"> visto de confirmação

   O seletor antigo era '.add-to-cart-icon, .quick-add__button .svg-wrapper',
   e esse segundo pedaço pegava os dois. Resultado: quem clicava em Adicionar
   via um segundo carrinho entrar por cima da palavra, no lugar do visto de
   "adicionado". Relatado pelo cliente com print.

   Agora o seletor é só '.add-to-cart-icon', que existe nos dois lugares que
   interessam (card e página do produto) e em nenhum outro. **Não volte a
   varrer .svg-wrapper solto dentro do botão.**
   ========================================================================== */

(function () {
  'use strict';

  var SEM_ESTOQUE = /esgotad|indispon|sold\s*out|out of stock/i;

  var CARRINHO =
    '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" ' +
    'stroke="currentColor" stroke-width="1.9" stroke-linecap="round" ' +
    'stroke-linejoin="round" aria-hidden="true" focusable="false" ' +
    'data-atd-carrinho>' +
    '<path d="M2 3h2.4l2.6 12.4a1.6 1.6 0 0 0 1.6 1.3h8.6a1.6 1.6 0 0 0 1.6-1.3l0.9-4.6"/>' +
    '<path d="M6.4 9.6h7.2"/>' +
    '<path d="M17.4 2.6v5"/>' +
    '<path d="M14.9 5.1h5"/>' +
    '<circle cx="10" cy="20.2" r="1.4"/>' +
    '<circle cx="17.4" cy="20.2" r="1.4"/>' +
    '</svg>';

  function trocarIcones() {
    var caixas = document.querySelectorAll('.add-to-cart-icon');
    for (var i = 0; i < caixas.length; i++) {
      var caixa = caixas[i];
      // Cinto e suspensório: mesmo que um dia a classe apareça no ícone de
      // confirmação, ele fica de fora.
      if (caixa.classList.contains('add-to-cart__added-icon')) continue;
      if (caixa.closest('.add-to-cart__added')) continue;
      if (caixa.querySelector('[data-atd-carrinho]')) continue;
      caixa.innerHTML = CARRINHO;
    }
  }

  function estaEsgotado(card) {
    var marcas = card.querySelectorAll('[class*="badge"], [class*="sold-out"], [class*="sold_out"]');
    for (var i = 0; i < marcas.length; i++) {
      if (SEM_ESTOQUE.test(marcas[i].textContent || '')) return true;
    }
    return false;
  }

  // Sobe do card até o filho direto da grade, que é quem aceita order.
  function celula(card) {
    var no = card;
    while (no.parentElement && no.parentElement !== document.body) {
      var caixa = getComputedStyle(no.parentElement).display;
      if (caixa === 'grid' || caixa === 'flex') return no;
      no = no.parentElement;
    }
    return null;
  }

  function avisar(card) {
    if (card.querySelector('.atd-esgotado__aviso')) return;
    var preco = card.querySelector('.price');
    var aviso = document.createElement('span');
    aviso.className = 'atd-esgotado__aviso';
    aviso.textContent = 'Consulte disponibilidade';
    if (preco && preco.parentElement) {
      preco.parentElement.appendChild(aviso);
    } else {
      card.appendChild(aviso);
    }
  }

  // Verdadeiro quando o último lote da lista já está na tela, ou quando a
  // página nem é uma lista paginada (home, vitrine, peças do mesmo motor).
  function filaCompleta(celulaExemplo) {
    var grade = celulaExemplo && celulaExemplo.closest('[data-last-page]');
    if (!grade) return true;

    var ultima = Number(grade.getAttribute('data-last-page') || 1);
    if (!ultima || ultima <= 1) return true;

    var carregadas = grade.querySelectorAll('[data-page]');
    var maior = 0;
    for (var i = 0; i < carregadas.length; i++) {
      var n = Number(carregadas[i].getAttribute('data-page') || 0);
      if (n > maior) maior = n;
    }
    return maior >= ultima;
  }

  function mostrarOuEsconder() {
    var fora = document.querySelectorAll('[data-atd-celula-esgotada]');
    for (var i = 0; i < fora.length; i++) {
      var celulaEsgotada = fora[i];
      var esconde = !filaCompleta(celulaEsgotada);
      var atual = celulaEsgotada.style.display === 'none';
      if (esconde === atual) continue;
      celulaEsgotada.style.display = esconde ? 'none' : '';
    }
  }

  function varrerCards() {
    var cards = document.querySelectorAll('product-card, .product-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.dataset.atdEstoque) continue;
      if (!estaEsgotado(card)) {
        card.dataset.atdEstoque = 'tem';
        continue;
      }
      card.dataset.atdEstoque = 'fora';
      card.classList.add('atd-esgotado');
      avisar(card);
      var alvo = celula(card);
      if (alvo) {
        alvo.style.order = '1';
        alvo.setAttribute('data-atd-celula-esgotada', '');
      }
    }
    mostrarOuEsconder();
  }

  // Na página do produto quem sabe do estoque é a ficha da peça, que já
  // acompanha a variação escolhida. O CSS lê esta classe no body.
  function conferirProduto() {
    var ficha = document.querySelector('[data-atd-ficha]');
    if (!ficha) return;
    var fora = !!ficha.querySelector('.atd-ficha__estoque--sem');
    document.body.classList.toggle('atd-sem-estoque', fora);
  }

  function varrer() {
    trocarIcones();
    varrerCards();
    conferirProduto();
  }

  function ligar() {
    varrer();
    // A listagem troca de página e de filtro sem recarregar, a home monta os
    // cards depois, e a ficha se reescreve quando a variação muda. Um
    // observer resolve os três casos.
    var pendente = false;
    var observador = new MutationObserver(function () {
      if (pendente) return;
      pendente = true;
      window.requestAnimationFrame(function () {
        pendente = false;
        varrer();
      });
    });
    observador.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ligar);
  } else {
    ligar();
  }
})();
